export const textoSx = {
    padding: '10px'
}
